import React, { useContext, useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import NProgress from 'nprogress';
import { useTheme } from '../context/ThemeContext';
import { FaMoon, FaSun, FaHome, FaPaperPlane, FaHistory, FaGavel, FaKey, FaUserCircle, FaSignOutAlt, FaMoneyBill } from 'react-icons/fa';

const Layout = () => {
  const { user, logout } = useContext(AuthContext);
  const { theme, toggleTheme } = useTheme();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    NProgress.start();
    logout();
    navigate('/login');
    NProgress.done();
  };

  const activeLinkClass = "bg-indigo-800 text-white";
  const normalLinkClass = "text-gray-300 hover:bg-indigo-700 hover:text-white";

  return (
    <div className={`min-h-screen ${theme === 'dark' ? 'bg-gray-900 text-white' : 'bg-gray-100 text-gray-900'}`}>
      <nav className="bg-indigo-900 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center">



              
              <div className="flex-shrink-0">
                <span className="text-white font-bold text-xl">
                  <NavLink to="/" className="px-2 py-3">SMS Gateway</NavLink>
                </span>
              </div>




              {/* Desktop Navigation */}
              <div className="hidden md:block">
                <div className="ml-10 flex items-baseline space-x-4">
                  <NavLink
                    to="/send-sms"
                    className={({ isActive }) =>
                      `flex items-center gap-1 px-3 py-2 rounded-md text-sm font-medium ${isActive ? activeLinkClass : normalLinkClass}`
                    }
                  >
                    <FaPaperPlane /> SMS ýaz
                  </NavLink>

                  <NavLink
                    to="/sms-history"
                    className={({ isActive }) =>
                      `flex items-center gap-1 px-3 py-2 rounded-md text-sm font-medium ${isActive ? activeLinkClass : normalLinkClass}`
                    }
                  >
                    <FaHistory /> Taryh
                  </NavLink>

                  <NavLink
                    to="/rules"
                    className={({ isActive }) =>
                      `flex items-center gap-1 px-3 py-2 rounded-md text-sm font-medium ${isActive ? activeLinkClass : normalLinkClass}`
                    }
                  >
                    <FaGavel /> Düzgünler
                  </NavLink>

                  {(user?.role === 'admin' || user?.role === 'developer') && (
                    <NavLink
                      to="/create-token"
                      className={({ isActive }) =>
                        `flex items-center gap-1 px-3 py-2 rounded-md text-sm font-medium ${isActive ? activeLinkClass : normalLinkClass}`
                      }
                    >
                      <FaKey /> API SMS
                    </NavLink>
                  )}
                  {(user?.role === 'admin') && (
                    <NavLink
                      to="/add-balance"
                      className={({ isActive }) =>
                        `flex items-center gap-1 px-3 py-2 rounded-md text-sm font-medium ${isActive ? activeLinkClass : normalLinkClass}`
                      }
                    >
                      <FaMoneyBill /> Balans goşmak
                    </NavLink>
                  )}
                </div>
              </div>
            </div>

            {/* Mobile menu button */}
            <div className="md:hidden flex items-center">
              <button
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-indigo-700 focus:outline-none"
              >
                <svg
                  className="h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  {isMobileMenuOpen ? (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  ) : (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                  )}
                </svg>
              </button>
            </div>

            {/* Desktop Profile/Logout */}
            <div className="hidden md:flex items-center">
              <NavLink
                to="/profile"
                className={({ isActive }) =>
                  `flex items-center gap-1 px-3 py-2 rounded-md text-sm font-medium mr-2 ${isActive ? activeLinkClass : normalLinkClass}`
                }
              >
                <FaUserCircle /> Hasap
              </NavLink>

              <button
                onClick={handleLogout}
                className="flex items-center gap-1 px-3 py-2 rounded-md text-sm font-medium text-gray-300 hover:bg-indigo-700 hover:text-white"
              >
                <FaSignOutAlt /> Çykyş
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-indigo-800">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
              <NavLink
                to="/send-sms"
                className={({ isActive }) =>
                  `flex items-center gap-2 px-3 py-2 rounded-md text-base font-medium ${isActive ? activeLinkClass : normalLinkClass}`
                }
              >
                <FaPaperPlane /> SMS ýaz
              </NavLink>

              <NavLink
                to="/sms-history"
                className={({ isActive }) =>
                  `flex items-center gap-2 px-3 py-2 rounded-md text-base font-medium ${isActive ? activeLinkClass : normalLinkClass}`
                }
              >
                <FaHistory /> Taryh
              </NavLink>

              <NavLink
                to="/rules"
                className={({ isActive }) =>
                  `flex items-center gap-2 px-3 py-2 rounded-md text-base font-medium ${isActive ? activeLinkClass : normalLinkClass}`
                }
              >
                <FaGavel /> Düzgünler
              </NavLink>

              {(user?.role === 'admin' || user?.role === 'developer') && (
                <NavLink
                  to="/create-token"
                  className={({ isActive }) =>
                    `flex items-center gap-2 px-3 py-2 rounded-md text-base font-medium ${isActive ? activeLinkClass : normalLinkClass}`
                  }
                >
                  <FaKey /> API SMS
                </NavLink>
              )}

              {(user?.role === 'admin') && (
                    <NavLink
                      to="/add-balance"
                      className={({ isActive }) =>
                        `flex items-center gap-2 px-3 py-2 rounded-md text-base font-medium ${isActive ? activeLinkClass : normalLinkClass}`
                      }
                    >
                      <FaMoneyBill /> Balans goşmak
                    </NavLink>
                  )}

              <div className="border-t border-indigo-700 pt-2">
                <NavLink
                  to="/profile"
                  className={({ isActive }) =>
                    `flex items-center gap-2 px-3 py-2 rounded-md text-base font-medium ${isActive ? activeLinkClass : normalLinkClass}`
                  }
                >
                  <FaUserCircle /> Hasap
                </NavLink>

                <button
                  onClick={handleLogout}
                  className="w-full flex items-center gap-2 px-3 py-2 rounded-md text-base font-medium text-gray-300 hover:bg-indigo-700 hover:text-white"
                >
                  <FaSignOutAlt /> Çykyş
                </button>
              </div>
            </div>
          </div>
        )}
      </nav>

      <main className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8 p-3">
        <Outlet />

      </main>
      <center className='p-3'>&copy; 2025 PALONE_DEV</center>
    </div>
  );
};

export default Layout;
